import React from "react";

import { Link, useLocation } from "react-router-dom";
import { Badge, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useTranslation } from "react-i18next";
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { useChatSummary } from "../pages/Chat";

const tabFor = (path) => {
  if (path.startsWith("/chats")) return "chats";
  if (path === "/" || path.startsWith("/activeevent")) return "myevents";
  if (path === "/profile" || path.startsWith("/matchprofile")) return "profile";
  return "home";
};

const Layout = ({ children, user }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [value, setValue] = React.useState(() => tabFor(location.pathname));
  const chat = useChatSummary();
  const flushTop = location.pathname === "/profile" || location.pathname.startsWith("/activeevent");
  const chromeless = location.pathname.startsWith("/setup");

  React.useEffect(() => {
    setValue(tabFor(location.pathname));
  }, [location.pathname]);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100dvh", boxSizing: "border-box", overflow: "hidden", paddingTop: flushTop || chromeless ? 0 : 20 }}>
      <main style={{ flex: 1, minHeight: 0, overflowY: "auto", WebkitOverflowScrolling: "touch", scrollPaddingBottom: 250 }}>
        {children}
      </main >
      {!chromeless && <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        style={{position:'fixed', bottom:0, width:'100%', borderTop: '1px solid lightgrey', boxShadow: '0px -1px 9px lightgrey'}}
      >
        <BottomNavigationAction value="home" label={t('nav.home.button')} icon={<HomeIcon />} component={Link} to="/events"/>
        <BottomNavigationAction value="myevents" label={t('nav.myevents.button')} icon={<EventIcon />} component={Link} to="/"/>
        {chat.available && (
          <BottomNavigationAction
            value="chats"
            label={t('nav.chats.button')}
            icon={
              <Badge color="error" badgeContent={chat.unread > 99 ? "99+" : chat.unread} invisible={!chat.unread}>
                <ChatBubbleIcon />
              </Badge>
            }
            component={Link}
            to="/chats"
          />
        )}
        <BottomNavigationAction value="profile" label={t('nav.profile.button')} icon={<AccountCircleIcon />} component={Link} to="/profile"/>
      </BottomNavigation>}
    </div>
  );
};

export default Layout;
